<template>
	<div class="connection-sustainability-score">
		<h2 class="connection-sustainability-score__title">{{ title }}</h2>
		<v-row align="center" justify="space-around" class="connection-sustainability-score__metrics ma-0 flex-nowrap">
			<v-col
				v-for="metric in metrics"
				:key="metric.key"
				cols="3"
				class="connection-sustainability-score__metric text-center px-1"
				:class="{ inactive: metric.score == null }"
			>
				<h3 class="connection-sustainability-score__label">{{ metric.label }}</h3>
				<div class="connection-sustainability-score__ring mx-auto">
					<vue-ellipse-progress
						:progress="metric.progress"
						:thickness="15"
						:size="118"
						:legend="false"
						:emptyColor="metric.score != null ? 'transparent' : '#b1b3b2'"
						:color="metric.color"
					/>
					<img
						:src="metric.icon"
						class="connection-sustainability-score__icon"
						:alt="metric.label"
					/>
				</div>
				<p class="connection-sustainability-score__value mb-0">
					{{ formatScore(metric.score) }}
				</p>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { VueEllipseProgress } from "vue-ellipse-progress"

export default {
	name: "ConnectionSustainabilityScore",
	components: { VueEllipseProgress },
	props: {
		title: String,
		score1: Number,
		score2: Number,
		score3: Number,
		score4: Number,
	},
	methods: {
		formatScore(score) {
			if (score == null || Number.isNaN(Number(score))) {
				return "-"
			}
			return `${Math.ceil(Number(score))}%`
		},
	},
	computed: {
		metrics() {
			return [
				{
					key: "human-rights",
					label: "HUMAN RIGHTS",
					score: this.score1,
					progress: this.score1 != null ? this.score1 : 100,
					color: this.score1 != null ? "#1E7C83" : "#b1b3b2",
					icon: require("../assets/Global_Compact_HumanRights.svg"),
				},
				{
					key: "labour",
					label: "LABOUR",
					score: this.score2,
					progress: this.score2 != null ? this.score2 : 100,
					color: this.score2 != null ? "#DE8F18" : "#b1b3b2",
					icon: require("../assets/Global_Compact_Labour.svg"),
				},
				{
					key: "environment",
					label: "ENVIRONMENT",
					score: this.score3,
					progress: this.score3 != null ? this.score3 : 100,
					color: this.score3 != null ? "#1E7C83" : "#b1b3b2",
					icon: require("../assets/Global_Compact_Environment.svg"),
				},
				{
					key: "anticorruption",
					label: "ANTICORRUPTION",
					score: this.score4,
					progress: this.score4 != null ? this.score4 : 100,
					color: this.score4 != null ? "#DE8F18" : "#b1b3b2",
					icon: require("../assets/Global_Compact_AntiCorruption.svg"),
				},
			]
		},
	},
}
</script>

<style scoped>
.connection-sustainability-score {
	max-width: 820px;
	margin: 0 auto;
}

.connection-sustainability-score__title {
	font-size: 1.3rem;
	font-weight: 600;
	line-height: 1.25;
	text-align: center;
	margin-bottom: 18px;
	color: #2f2f2f;
}

.connection-sustainability-score__label {
	font-size: 0.74rem;
	font-weight: 700;
	letter-spacing: 0.03em;
	line-height: 1.2;
	margin-bottom: 8px;
	color: #1e7c83;
}

.connection-sustainability-score__ring {
	width: 118px;
	height: 118px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 6px;
	position: relative;
}

.connection-sustainability-score__icon {
	position: absolute;
	top: 50%;
	left: 50%;
	width: 56px;
	height: 56px;
	transform: translate(-50%, -50%);
	object-fit: contain;
	pointer-events: none;
	z-index: 2;
}

.connection-sustainability-score__value {
	font-size: 1.85rem;
	font-weight: 700;
	line-height: 1.2;
	color: #1e7c83;
	position: relative;
	z-index: 1;
}

.inactive {
	filter: grayscale(100%);
}
</style>
